var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PropertyConverters, Utils, Watch } from '@pacem/pacem-core';
import { PacemContenteditableCommandElement } from '../contenteditable';
//namespace Pacem.Components.Scaffolding {
export class PacemContenteditableButtonCommandElement extends PacemContenteditableCommandElement {
    cleanUp(_) {
        // do nothing
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'range') {
            this.active = !Utils.isNull(val);
        }
    }
    getTooltip(altText = this.altText, shortcut = this.keyboardShortcut) {
        const hint = altText;
        if (Utils.isNullOrEmpty(shortcut)) {
            return hint;
        }
        return `${hint} (${shortcut})`;
    }
}
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemContenteditableButtonCommandElement.prototype, "icon", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemContenteditableButtonCommandElement.prototype, "keyboardShortcut", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemContenteditableButtonCommandElement.prototype, "altText", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemContenteditableButtonCommandElement.prototype, "active", void 0);
export const CONTENTELEMENT_BUTTONCOMMAND_TEMPLATE = `<${P}-button disabled="{{ !:host.active }}" css-class="{{ {'text-primary': :host.isRelevant(:host.range)} }}" tooltip="{{ :host.getTooltip(:host.altText, :host.keyboardShortcut) }}" class="button" on-click=":host.execCommand()"><${P}-icon class="text-rootsize" icon="{{ :host.icon }}"></${P}-icon></${P}-button>
                   <${P}-shortcut disabled="{{ !:host.active }}" target="{{ :host.contentElement }}" combination="{{ :host.keyboardShortcut }}" on-execute=":host.execCommand()"></${P}-shortcut>`;
//}
